import * as React from 'react';
import { monthsList } from '../constants/CommonConstants';
import PropTypes from 'prop-types';
import { DropDownComponent } from './DropDownComponent';

export class MiniCalendarComponent extends React.Component {

    constructor(props, state) {
        super(props, state);
        this.state = state;

        this.date = new Date();
        this.months = this.getMonthsList();
        this.years = this.getYearsList();
    }

    componentWillMount() {
        this.setState({
            startMonth: 0,
            startYear: this.date.getMonth() > 2 ? this.date.getFullYear() + 1 : this.date.getFullYear()
        });

    }

    getMonthsList() {
        if(this.props.useShortHand) {
            const months = [];
            monthsList.map((month) => {
                months.push(month.substring(0, 3));
            });
            return months;
        }

        return monthsList;
    }

    getYearsList() {
        const currentYear = this.date.getFullYear();
        const years = [];

        for(var i = 0; i < 3; i++) {
            years.push(currentYear + i);
        }

        return years;
    }

    render() {
        return(
            <div className={'mini-calendar'}>
                {this.props.label && this.props.label !== '' ? <label htmlFor="startMonth">{this.props.label}</label> : null}
                <DropDownComponent id="startMonth"
                    dropDownItems={this.months}
                    selected={this.state.startMonth}
                    value={this.state.startMonth + 1}
                    className={`month-list${this.props.useShortHand ? ' shorthand-month' : ''}`}
                    onClick={event => this.setState({ startMonth: Number(event.currentTarget.dataset.id) })} />

                <DropDownComponent id="startYear"
                    dropDownItems={this.years}
                    selected={this.years.indexOf(this.state.startYear)}
                    value={this.state.startYear}
                    className={'year-list'}
                    onClick={event => this.setState({ startYear: this.years[event.currentTarget.dataset.id] })} />
            </div>
        );
    }
}

MiniCalendarComponent.propTypes = {
    label: PropTypes.string,
    useShortHand: PropTypes.bool
};

MiniCalendarComponent.defaultProps = {
    label: '',
    useShortHand: false
};

